import api from 'apis/restaurant-api/api';
import { UiLanguageKey } from 'locale/languages';
import type { EnterpriseRole } from 'modules/access-control';

import { AccessDescription } from './types';

const enterprisesEndpoint = '/v1/merchant-admin/enterprises';

export const fetchEnterpriseAccess = (enterpriseId: string) =>
  api
    .get<{ results: AccessDescription[] }>(`${enterprisesEndpoint}/${enterpriseId}/access`)
    .then(response => response.data.results);

export const deleteEnterpriseAccess = (enterpriseId: string, userEmail: string, userId: string | undefined) =>
  api.delete(`${enterprisesEndpoint}/${enterpriseId}/access`, {
    data: {
      id: userId,
      email: userEmail,
    },
  });

export const grantTentativeEnterpriseAccess = (
  enterpriseId: string,
  email: string,
  role: EnterpriseRole,
  preferredLocale: UiLanguageKey,
) =>
  api.put(`${enterprisesEndpoint}/${enterpriseId}/access`, {
    email,
    role,
    preferred_locale: preferredLocale,
  });

export const grantEnterpriseAccess = (enterpriseId: string, userId: string, role: string) =>
  api.put(`${enterprisesEndpoint}/${enterpriseId}/access`, {
    id: userId,
    role,
  });
